var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 12h18v-2H0v2Zm0-5h18V5H0v2Zm0-7v2h18V0H0Z","fill":"currentColor"}));
}

Menu.defaultProps = {"width":"18","height":"12","viewBox":"0 0 18 12","fill":"none"};

module.exports = Menu;

Menu.default = Menu;
